"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoTexts = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
require("./style.scss");
var InfoTexts = function () { return (React.createElement("div", { className: 'info-texts animated fadeIn' },
    React.createElement("div", null,
        React.createElement("strong", null, (0, translation_1.getLocalization)('userfront/Login/Placeholder/SokoProHeldesk'))),
    React.createElement("div", null,
        React.createElement("strong", null,
            (0, translation_1.getLocalization)('userfront/Login/Placeholder/Openinghours'),
            ' ')),
    React.createElement("div", null,
        (0, translation_1.getLocalization)('userfront/Login/Placeholder/Telephone'),
        React.createElement("a", { target: '_blank', href: "tel:".concat((0, translation_1.getLocalization)('userfront/Login/Placeholder/TelephoneNumberLink')) },
            (0, translation_1.getLocalization)('userfront/Login/Placeholder/TelephoneNumber'),
            ' '),
        ' ',
        (0, translation_1.getLocalization)('userfront/Login/Placeholder/TelephoneNumberPricing')),
    React.createElement("div", null,
        React.createElement("a", { target: '_blank', href: "mailto:".concat((0, translation_1.getLocalization)('userfront/Login/Placeholder/mailToHelpdeskLink')) }, (0, translation_1.getLocalization)('userfront/Login/Placeholder/mailToHelpdesk')),
        "\u00A0\u2013\u00A0",
        React.createElement("a", { target: '_blank', href: 'https://www.sokopro.com' }, "www.sokopro.com")))); };
exports.InfoTexts = InfoTexts;
